export default __webpack_public_path__ + "media/123456.e5fb8224.png";